import {Component, Inject} from '@angular/core'
import {SelectionModel} from '@angular/cdk/collections'
import {ChangeDetails} from '../common/domain/change'
import {MatTableDataSource} from '@angular/material/table'
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog'

export interface GitPublishDialogData {
  cancelled?: boolean
  title: string
  changes: ChangeDetails[]
}

class ChangeDataSource {
  dataSource: MatTableDataSource<ChangeDetails>
  selection: SelectionModel<ChangeDetails>
  displayedColumns = ['select', 'name', 'action']

  constructor(public title: string, data: ChangeDetails[]) {
    this.dataSource = new MatTableDataSource<ChangeDetails>(data)
    this.selection = new SelectionModel<ChangeDetails>(true, data)
  }

  hasData() {
    return this.dataSource.data.length > 0
  }

  masterToggle() {
    if (this.allSelected()) {
      this.selection.clear()
    } else {
      this.dataSource.data.forEach(row => {
        this.selection.select(row)
      })
    }
  }

  allSelected() {
    return this.selection.selected.length === this.dataSource.data.length
  }

  toggle(row: ChangeDetails) {
    this.selection.toggle(row)
  }
}

@Component({
  selector: 'app-git-publish-dialog',
  templateUrl: 'git-publish-dialog.component.html',
  styleUrls: ['./git-publish-dialog.component.scss'],
})
export class GitPublishDialogComponent {
  dataSources: ChangeDataSource[] = []

  constructor(public dialogRef: MatDialogRef<GitPublishDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: GitPublishDialogData) {
    this.dataSources.push(new ChangeDataSource('Configurations', data.changes.filter(c => c.path.startsWith('settings'))))
    this.dataSources.push(new ChangeDataSource('Schemas', data.changes.filter(c => c.path.startsWith('schemas'))))
    this.dataSources.push(new ChangeDataSource('Transforms', data.changes.filter(c => c.path.startsWith('transforms'))))
    this.dataSources.push(new ChangeDataSource('Templates', data.changes.filter(c => c.path.startsWith('templates'))))
    this.dataSources.push(new ChangeDataSource('Samples', data.changes.filter(c => c.path.startsWith('samples'))))
    this.dataSources.push(new ChangeDataSource('Targets', data.changes.filter(c => c.path.startsWith('publish'))))
    this.dataSources.push(new ChangeDataSource('Experiments', data.changes.filter(c => c.path.startsWith('experiments'))))
    this.dataSources.push(new ChangeDataSource('Static', data.changes.filter(c => c.path.startsWith('static'))))
  }

  cancel() {
    this.dialogRef.close(Object.assign({}, this.data, {
      cancelled: true,
      changes: [],
    }))
  }

  publish() {
    const changes = this.getSelectedChanges()

    this.dialogRef.close(Object.assign({}, this.data, {
      cancelled: false,
      changes: changes,
    }))
  }

  private getSelectedChanges() {
    const changes = []
    this.dataSources.forEach(dataSource => {
      dataSource.selection.selected.forEach(change => {
        changes.push(change)
      })
    })
    return changes
  }

  errorMessage() {
    if (this.getSelectedChanges().length > 99) {
      return 'Too many files to commit - please select a maximum of 100'
    }
    return undefined
  }

  valid() {
    if (this.getSelectedChanges().length === 0) {
      return false
    }
    if (this.getSelectedChanges().length > 99) {
      return false
    }
    return true
  }
}
